import { useCallback } from 'react';
import { useThrottleFn, useEvent, useCounter } from 'react-use';
import { appRefreshAll } from 'data/app/actions';
import { useAppDispatch, useAppSelector } from 'app-components/hooks/redux';
import { featureFlagsSelectors } from 'app-components/flux/feature-flags';

export const useAutoRefresh = () => {
  const dispatch = useAppDispatch();
  const systemAutoRefreshThrottleOperations =
    useAppSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'systemAutoRefreshThrottleOperations')) ?? -1;
  const [triggerCounter, { inc: incrementTrigger }] = useCounter(0);
  const onVisibilityChange = useCallback(() => {
    if (systemAutoRefreshThrottleOperations >= 0 && document.visibilityState === 'visible') {
      incrementTrigger();
    }
  }, [systemAutoRefreshThrottleOperations, incrementTrigger]);
  useEvent('visibilitychange', onVisibilityChange);
  useThrottleFn(
    (value) => {
      if (systemAutoRefreshThrottleOperations >= 0 && value) {
        dispatch(appRefreshAll(undefined, { context: 'visibilityChange' }));
      }
      return value;
    },
    systemAutoRefreshThrottleOperations,
    [triggerCounter, dispatch, systemAutoRefreshThrottleOperations],
  );
};

export default useAutoRefresh;
